import { Component, OnInit , AfterViewInit , Input} from '@angular/core';

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-expert-hints',
  templateUrl: './expert-hints.component.html',
  styleUrls: ['./expert-hints.component.css',]
})
export class ExpertHintsComponent implements OnInit , AfterViewInit{
    @Input() isExcellent:boolean;
    @Input() title:string;
    @Input() content:string;
    @Input() summary:string;
    @Input() activity:true;

  constructor() { }

  ngOnInit() {

  }

  ngAfterViewInit(){
      var htmlFontSize=document.documentElement.clientWidth/7.5;
      document.documentElement.style.fontSize=htmlFontSize+"px";
      if(this.activity){
        $("#experts_hints_picture").css({
            'background-image':'url("../../assets/picture/activity/DDI.jpg")',
            'background-size': '1.2rem 1.2rem;',
            'background-position':'center',
            'background-repeat':'no-repeat;'
        });
        $("#experts_hints_title").css({
            'font-weight':'normal',
        });
        $("#experts_hints_content").css({
            'margin-top':'0.45rem',
            'text-align':'center'
        });

        $("#expert_hints_wrap").css({
            "padding-bottom":"0.8rem"
        });


        let screenWidth = document.documentElement.clientWidth;
        if(screenWidth<359){
            $("#experts_hints_title").css({
                'font-size':'12px',
            });
            $("#experts_hints_content").css({
                'font-size':'15px',
            });
        }else if(screenWidth>=359&&screenWidth<375){
            $("#experts_hints_title").css({
                'font-size':'13px',
            });
            $("#experts_hints_content").css({
                'font-size':'17px',
            });
        }else if(screenWidth>=375&&screenWidth<412){
            $("#experts_hints_title").css({
                'font-size':'14px',
            });
            $("#experts_hints_content").css({
                'font-size':'18px',
            });
        }else if(screenWidth>=412&&screenWidth<750){
            $("#experts_hints_title").css({
                'font-size':'15px',
            });
            $("#experts_hints_content").css({
                'font-size':'19px',
            });
        }else{
            $("#experts_hints_title").css({
                'font-size':'28px',
            });
            $("#experts_hints_content").css({
                'font-size':'36px',
            });
        }
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/expert-hints/expert-hints.component.ts